import keyBy from 'lodash/keyBy';

import {
	StoreAsyncItem,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction
} from '../../../flux';
import { counterpartyActionsPack } from '../actions';


export interface ICounterpartyState {
	tenantEntities: StoreAsyncItem<Record<string, CounterpartyBrief>>;
}

const initialState = {
	tenantEntities: createAsyncInitialState<Record<string, CounterpartyBrief>>(),
};

const counterpartyReducer = createReducer(initialState, {
	[counterpartyActionsPack.types.FETCH_TENANT_ENTITIES]: (action, state) => {
		return {
			tenantEntities: checkAsyncAction<Array<CounterpartyBrief>>(action, state.tenantEntities, item => keyBy(item, item => item.ID)),
		};
	},
});

export default counterpartyReducer;
